import { createAction } from '@helpers/createAction'

export const HR_APPLICATION = 'HR_APPLICATION'
export const HR_APPLICATIONS = 'HR_APPLICATIONS'
export const HR_APPLICATION_CREATE = 'HR_APPLICATION_CREATE'
export const HR_APPLICATION_DELETE = 'HR_APPLICATION_DELETE'
export const HR_APPLICATION_LIST = 'HR_APPLICATION_LIST'
export const HR_APPLICATION_ALL = 'HR_APPLICATION_ALL'
export const HR_APPLICATION_TYPES = 'HR_APPLICATION_TYPES'
export const HR_APPLICATION_STATUS = 'HR_APPLICATION_STATUS'

export const HR_APPLICATION_FIELD_BATCH = 'HR_APPLICATION_FIELD_BATCH'
export const HR_APPLICATION_FIELD_BATCH_CREATE = 'HR_APPLICATION_FIELD_BATCH_CREATE'

// category
export const HR_APPLICATION_CATEGORY = 'HR_APPLICATION_CATEGORY'
export const HR_APPLICATION_CATEGORY_CREATE = 'HR_APPLICATION_CATEGORY_CREATE'
export const HR_APPLICATION_CATEGORY_DELETE = 'HR_APPLICATION_CATEGORY_DELETE'
export const HR_APPLICATION_CATEGORY_LIST = 'HR_APPLICATION_CATEGORY_LIST'
export const HR_APPLICATION_CATEGORY_ALL = 'HR_APPLICATION_CATEGORY_ALL'

// request
export const HR_APPLICATION_REQUEST = 'HR_APPLICATION_REQUEST'
export const HR_APPLICATION_REQUEST_ALL = 'HR_APPLICATION_REQUEST_ALL'
export const HR_APPLICATION_REQUEST_EDIT = 'HR_APPLICATION_REQUEST_EDIT'
export const HR_APPLICATION_REQUEST_UPDATE = 'HR_APPLICATION_REQUEST_UPDATE'

export default {
  [HR_APPLICATION]: createAction(HR_APPLICATION),
  [HR_APPLICATION_CREATE]: createAction(HR_APPLICATION_CREATE),
  [HR_APPLICATION_DELETE]: createAction(HR_APPLICATION_DELETE),
  [HR_APPLICATION_STATUS]: createAction(HR_APPLICATION_STATUS),
  [HR_APPLICATION_LIST]: createAction(HR_APPLICATION_LIST),
  [HR_APPLICATION_ALL]: createAction(HR_APPLICATION_ALL),
  [HR_APPLICATION_TYPES]: createAction(HR_APPLICATION_TYPES),
  [HR_APPLICATION_FIELD_BATCH]: createAction(HR_APPLICATION_FIELD_BATCH),
  [HR_APPLICATION_FIELD_BATCH_CREATE]: createAction(HR_APPLICATION_FIELD_BATCH_CREATE),
  [HR_APPLICATION_CATEGORY]: createAction(HR_APPLICATION_CATEGORY),
  [HR_APPLICATION_CATEGORY_CREATE]: createAction(HR_APPLICATION_CATEGORY_CREATE),
  [HR_APPLICATION_CATEGORY_DELETE]: createAction(HR_APPLICATION_CATEGORY_DELETE),
  [HR_APPLICATION_CATEGORY_LIST]: createAction(HR_APPLICATION_CATEGORY_LIST),
  [HR_APPLICATION_CATEGORY_ALL]: createAction(HR_APPLICATION_CATEGORY_ALL),
  [HR_APPLICATION_REQUEST]: createAction(HR_APPLICATION_REQUEST),
  [HR_APPLICATION_REQUEST_ALL]: createAction(HR_APPLICATION_REQUEST_ALL),
  [HR_APPLICATION_REQUEST_EDIT]: createAction(HR_APPLICATION_REQUEST_EDIT),
  [HR_APPLICATION_REQUEST_UPDATE]: createAction(HR_APPLICATION_REQUEST_UPDATE),
}
